import React, { FC, useEffect, useRef } from 'react';
import { useSpring, animated } from '@react-spring/web';
import { StoryProgress, UnitName, UnitPhoto } from '$shared/components';
import { IcClose28, IcSoundOff24, IcSoundOn24 } from '$assets';
export const StoryTape: FC<StoryTapeProps> = ({
  width,
  height,
                                                storyIndex,
  onClose,
  onChangeStory,

  onChangeUser,
  children
}) => {
  const slideIndex = useRef(storyIndex);
  const count = React.Children.count(children);

  const pointerTimer = useRef(0);
  const [{ offsetX, offsetY }, api] = useSpring(() => ({
    offsetX: -slideIndex.current * width,
    offsetY: 0,
    opacity: 1,
    immediate: true,
    config: {
      tension: 350,
      clamp: true,
    },
  }));

  useEffect(() => {
    slideIndex.current = storyIndex;
  }, [storyIndex]);


  useEffect(() => {
    api.start({
      offsetX: storyIndex * -width,
    });
  }, [storyIndex]);

  const bind = useGesture(
    {
      onPointerDown: (e) => {
        pointerTimer.current = Date.now();
        dispatchEvent(new CustomEvent('storyPause'));
      },
      onDrag: ({
        down,
        xy: [x],
        tap,
        timeStamp,
        startTime,
        movement: [mx, my],
        ...e
      }) => {
        if (down) {
          dispatchEvent(new CustomEvent('storyPause'));
        } else {
          dispatchEvent(new CustomEvent('storyPlay'));
        }

        if (Math.abs(my) > Math.abs(mx)) {
          if (!down) {
            const speed = my / (timeStamp - startTime);
            if (Math.abs(speed) > 0.4) {
              api.start({
                opacity: 0,
                offsetY: -height * 1.2 * (speed > 0 ? -1 : 1),
                onRest: ({ finished }) => {
                  finished && onClose && onClose();
                },
              });
            } else if (Math.abs(my) > height / 5) {
              api.start({
                opacity: 0,
                offsetY: -height * 1.2 * (my > 0 ? -1 : 1),
                onRest: ({ finished }) => {
                  finished && onClose && onClose();
                },
              });
            } else {
              api.start({
                opacity: 1,
                offsetY: 0,
              });
            }
          } else {
            const opacity = 1 - Math.abs(my) / height;
            api.start({
              offsetY: my,
              opacity: opacity,
              immediate: true,
            });
          }
          return;
        }

        if (tap && Date.now() - pointerTimer.current < 500) {
          const target = e.currentTarget as HTMLElement;
          const { left } = target.getBoundingClientRect();
          onChangeStory(x - left > width / 3 ? 1 : -1);
        }

        const isEdge =
          (slideIndex.current === 0 && mx > 0) ||
          (slideIndex.current === count - 1 && mx < 0);
        if (!down) {
          const speed = mx / (timeStamp - startTime);
          let offset = 0;
          if (isEdge) {
            offset = 0;
          } else if (Math.abs(speed) > 0.4) {
            offset = speed > 0 ? -1 : 1;
          } else if (Math.abs(mx) > width / 3) {
            offset = mx > 0 ? -1 : 1;
          }
          slideIndex.current += offset;
          mx && api.start({
            offsetX: slideIndex.current * -width,
            onRest: (
              { finished }) => {
              offset && !isEdge && onChangeUser(slideIndex.current);
            },
          });
        } else {
          api.start({
            offsetX: -slideIndex.current * width + mx / (isEdge ? 5 : 1),
            immediate: true,
          });
        }
      },
    },
    {
      drag: { axis: 'lock', filterTaps: true },
    },
  );

  return (
    <div className="StoryViewer__view" {...bind()}>
      <animated.div
        className="StoryViewer__tape"
        style={{
          width: width * count + 'px',
          x: offsetX,
          y: offsetY,
        }}
      >
        {children}
      </animated.div>
    </div>
  );
};

import { useGesture } from '@use-gesture/react';
import { StoryTapeProps } from '$core/StoryViewer/StoryViewer.interface';
